import { FormItem } from '@/components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledLinkInputWrapper = styled.div`
  margin-bottom: 1rem;

  .ant-form-item {
    margin-bottom: 0;
    .ant-form-item-control {
      display: grid;
      align-items: center;
      column-gap: 1rem;
      grid-template-columns: auto 1fr;
      grid-template-areas: 'extra input' 'error -';

      .ant-form-item-control-input {
        flex-grow: 1;
        grid-area: input;
      }

      .ant-form-item-extra {
        min-height: auto;
        grid-area: extra;
      }
    }
  }
`;

export const StyledDivider = styled.div`
  border-bottom: 1px solid ${COLORS.GRAY_LIGHT};
  margin-top: 0.5rem;

  :last-child {
    border-bottom: 0px;
  }
`;

export const StyledWrapper = styled.div`
  display: flex;

  h3 {
    ${pickThemeFontStyles('14', '22', 'SEMI_BOLD')};
    margin: 0;
  }
`;

export const StyledFormListItem = styled(FormItem)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;
`;
